import { Menu, Typography } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { NavLink, useLocation } from 'react-router-dom';

const TeamAdminSider = () => {
  const { pathname } = useLocation();
  return (
    <Sider style={{ minHeight: '100vh' }}>
      <Typography style={{ color: 'white', fontSize: '1.5em', fontWeight: 600, padding: 32, paddingTop: 16 }}>
        WTC Team Admin</Typography>
      <Menu
        theme='dark'
        mode='inline'
        defaultSelectedKeys={['/']}
        selectedKeys={[pathname]}
        items={[
          {
            key: '/',
            label: <NavLink to={'/'}>Home</NavLink>,
          },
          {
            key: '/teams',
            label: <NavLink to={'/teams'}>Teams</NavLink>,
          },
          // {
          //   key: '/list-checker',
          //   label: <NavLink to={'/list-checker'}>List Checker</NavLink>,
          // },
        ]}
      />
    </Sider>
  );
};

export default TeamAdminSider;
